module.exports = __webpack_public_path__ + "static/img/temp-mobile-contents02@w.4c2f236.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-mobile-contents02@w.jpg
// module id = VwOn
// module chunks = 0